import { Module } from "wrapper6";
import smoothscroll from 'smoothscroll-polyfill';

export default class CoverScroll extends Module {
  ready() {
    const COVER = document.querySelector('.mtt-cover-image');

    if (COVER) {
      const ARROW = COVER.querySelector('.scroll-arrows');
      smoothscroll.polyfill();

      ARROW.addEventListener('click', () => {
        window.scroll({
          top: COVER.offsetHeight / 1.2,
          left: 0,
          behavior: 'smooth'
        })
      });
    }
  }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_cover-scroll.js